/**
 * @typedef {object} TownOnlineGoals
 * @property {string} viewClinicTab - Открытие вкладки "В клинике".
 * @property {string} viewOnlineTab - Открытие вкладки "Онлайн".
 * @property {string} filteredDoctor - Отфильтровал врачей на вкладке "Онлайн".
 * @property {string} clickSlot - Редирект по слоту любого врача из вкладки "Онлайн".
 * @property {string} viewAppointmentTelemed - Открытие формы записи на Телемед.
 * @property {string} redirectedToTelemedPayment - Редирект к оплате Телемеда.
 * @property {string} openScheduleDoctor - Открыл расписание врача на форме записи.
 * @property {string} chooseAnotherTime - Выбрал другое время на форме записи.
 */

/** @type {TownOnlineGoals} */
const TOWN_ONLINE_GOALS = {
  viewClinicTab: 'townOnline__viewClinicTab',
  viewOnlineTab: 'townOnline__viewOnlineTab',
  filteredDoctor: 'townOnline__filteredDoctor',
  clickSlot: 'townOnline__clickSlot',
  viewAppointmentTelemed: 'townOnline__viewAppointmentTelemed',
  redirectedToTelemedPayment: 'townOnline__redirectedToTelemedPayment',
  openScheduleDoctor: 'townOnline__openScheduleDoctor',
  chooseAnotherTime: 'townOnline__chooseAnotherTime',
}

export default TOWN_ONLINE_GOALS
